/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Operator to use for the condition
 */
export type CreateWorkflowDtoOperator = (typeof CreateWorkflowDtoOperator)[keyof typeof CreateWorkflowDtoOperator];

export const CreateWorkflowDtoOperator = {
  '=': '=',
  '!=': '!=',
  '>': '>',
  '>=': '>=',
  '<': '<',
  '<=': '<=',
} as const;
